import { render, staticRenderFns } from "./PatientListForManager.vue?vue&type=template&id=8baf407a&scoped=true&"
import script from "./PatientListForManager.vue?vue&type=script&lang=js&"
export * from "./PatientListForManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8baf407a",
  null
  
)

export default component.exports